<div class="intralinks-management-container">
    <form class="form-group" [formGroup]="intralinsManagementForm">
        <div class="header-container">
            <span class="h3-regular header-title">{{'intralinks.intralinks_settings' | stringLiterals}}</span>
        </div>
        <div class="body-container">
            <div>
                <span class="span-intralinks body-3">{{'intralinks.hide_intralinks_on_menu' | stringLiterals}}</span>
            </div>
            <div class="switch-intralinks">
                <kendo-switch [checked]="isHideIntralinks" onLabel="Yes" offLabel="No"
                    (valueChange)="changeIntralinksStatus($event)">
                </kendo-switch>
            </div>
            <div class="intralinks-content">
                <div class="tam-form-field item" [ngClass]="{'has-error': uiUrl.invalid}">
                    <div><span class="body-3 item-label">{{'intralinks.intralinks_ui_url' | stringLiterals}}</span>
                    </div>
                    <div><input type="text" class="tam-textbox item-text" formControlName="uiUrl"
                            (keyup)="configChanged()" /></div>
                    <div class="tam-form-help" *ngIf="uiUrl.invalid && uiUrl.errors['required']">
                        {{'general.required_error_message' | stringLiterals}}
                    </div>
                </div>
                <div class="tam-form-field item" [ngClass]="{'has-error': serverUrl.invalid}">
                    <div><span class="body-3 item-label">{{'intralinks.intralinks_server_url' | stringLiterals}}</span>
                    </div>
                    <div><input type="text" class="tam-textbox item-text" formControlName="serverUrl"
                            (keyup)="configChanged()" /></div>
                    <div class="tam-form-help" *ngIf="serverUrl.invalid && serverUrl.errors['required']">
                        {{'general.required_error_message' | stringLiterals}}
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-container">
            <button tam-button tamType="primary" tamSize="normal" (click)="onSave()" [tamLoading]="isProgressing"
                [disabled]="isProgressing" class="dialog-button dialog-publish btn-save">{{'general.save' |
                stringLiterals}}</button>
        </div>
    </form>
</div>